<template>
    <section class="sk-home__section sk-home__sb-cats custom_made_gif sk-home__sb-gifts kts-pt-50 kts-pt-mb-50 kts-pb-25 kts-pb-mb-25" :class="check_service ? 'custom_our_service' : ''">
        <div class="sk-home__container">
            <div class="sk-home__heading">
                <h2 class="sk-home__heading-title">{{ data.heading }}</h2>
                <div class="sk-home__heading-description" v-html="htmlSpecialcharsDecode(data.description)"></div>
            </div>
            <div class="sk-home__content sk-home__content--sb-gifts kts-pt-25 kts-pt-mb-20">
                <div class="sb-gifts__items">
                    <div class="sb-cats__item-details sb_shop_gif" v-for="item in data.collections" :key="item">
                        <NuxtLink :to="getLangUrl(item.url, baseUrl, locale)" class="sb-cats__item-url">
                            <img width = "322" height = "322" class="alt-lazy-img sb-cats__item-thumbnail" :data-original_src="item.image_full" :src="item.image_thumbnail" :alt="item.alt || 'image'"/>
                                <!-- <button class="sb-cats__item-title">
                                    <span>{{ item.title }}</span>
                                </button> -->
                            <span class="sb-cats__item-title">{{ item.title }}</span>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    const props = defineProps(["data", "service"]);
    const data = props.data;
    const check_service = props.service ?? false;
    const runtimeConfig = useRuntimeConfig();
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';
    const baseUrl = runtimeConfig.public.BASE_URL;
</script>